import React from 'react';
import {
  Card, Skeleton, SkeletonBlock, SkeletonContent, SkeletonLine
} from '@one-thd/sui-atomic-components';

export const ProjectsCompletedSkeleton = () => (
  <div className="sui-flex sui-flex-col sui-gap-4">
    <SkeletonLine variant="heading" />
    <div className="sui-grid sui-grid-cols-1 md:sui-grid-cols-2 lg:sui-grid-cols-3 sui-gap-8">
      {Array(6).fill('').map((__, index) => (
        <Card key={index} className="sui-w-full" disablePadding>
          <Skeleton grow key={index} orientation="horizontal">
            <SkeletonContent density="loose" disablePadding initialSize="2/4">
              <SkeletonBlock aspect="wide" />
            </SkeletonContent>
            <SkeletonContent density="loose" disablePadding initialSize="2/4">
              <SkeletonLine numberOfLines={3} />
            </SkeletonContent>
          </Skeleton>
        </Card>
      ))}
    </div>
  </div>
);